import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useLocation } from "react-router-dom";
import Feedback from './Feedback';
import queryString from 'query-string'
import FeedbackActions from './FeedbackAction.js';
import ThankYouFeedback from './ThankYouFeedback.js';
import Loader from "../../components/Loader/Loader";
import "./Feedback.css"

export const index = (props) => {

  const location = useLocation()
  const [UserExisting, setUserExisting] = useState()
  const [CustomerExistinDb, setCustomerExistinDb] = useState()
  const parsed = queryString.parse(location.search);


  useEffect(() => {
    props?.checkUser(parsed?.email,parsed?.bookingid)
  }, [])


  useEffect(() => {
    setUserExisting(props?.UserExisting?.already_exists)
    setCustomerExistinDb(props?.UserExisting?.customer_exists)
    // setCustomerExistinDb(true)
    // setUserExisting(true)
  }, [props?.UserExisting?.already_exists])


  return (
    <div>
      {props.UserLoading ? <Loader />
        : CustomerExistinDb ?
          UserExisting ?
            <ThankYouFeedback />
            : <Feedback bookingid={parsed.bookingid} name={parsed.name} email={parsed.email} />
          : <div className="NotaCusotmerInDb"><h1 className="NotaCusotmerInDbh1">You are not a registered customer</h1></div>}
    </div>
  )
}

const mapStateToProps = (state) => ({
  UserExisting: state?.questionsDataReducer?.UserExisting,
  UserExistingFailed: state?.questionsDataReducer?.UserExistingFailed,
  UserLoading: state?.questionsDataReducer?.UserLoading
});

const mapDispatchToProps = (dispatch) => {
  return {
    checkUser: (email,booking) => {
      dispatch(FeedbackActions.checkUserExisting(email,booking));
    }
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(index)),
};
